import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, PawPrint } from "lucide-react";
import { Link } from "react-router-dom";
import { api, errText } from "../../lib/api";

export function LikeAlertsList() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/like-alerts").then((r) => setData(r.data)).catch((e) => toast.error(errText(e)));
  useEffect(() => { load(); }, []);
  const remove = async (a) => {
    if (!window.confirm(`Delete the “${a.label}” alert for ${a.email}?`)) return;
    try { await api.delete(`/admin/like-alerts/${a.id}`); toast.success("Alert deleted"); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  if (!data) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 p-6" data-testid="like-alerts">
      <h3 className="font-display font-bold text-[#12234A] flex items-center gap-2"><PawPrint size={16} className="text-[#F5551E]" /> “More like this” alerts <span className="text-sm font-normal text-slate-500" data-testid="like-alerts-count">({data.active} active)</span></h3>
      <p className="text-xs text-slate-500 mt-1 mb-4">From the listing-page popup. Each person gets one email a day with new matching listings, sent with the 9am daily tasks.</p>
      {data.items.length ? (
        <div className="overflow-x-auto max-h-[420px]">
          <table className="w-full text-sm" data-testid="like-alerts-table">
            <thead><tr className="text-left text-xs text-slate-400 uppercase tracking-wide"><th className="pb-2">Email</th><th className="pb-2">Wants</th><th className="pb-2">Where</th><th className="pb-2">Waiting</th><th className="pb-2">Emailed</th><th className="pb-2">Joined</th><th /></tr></thead>
            <tbody>
              {data.items.map((a) => (
                <tr key={a.id} className="border-b border-slate-100" data-testid={`like-row-${a.id}`}>
                  <td className="py-2.5 pr-3 font-medium text-[#12234A]">{a.email}{!a.active && <span className="ml-2 text-xs text-slate-400">(stopped)</span>}</td>
                  <td className="py-2.5 pr-3"><Link to={`/listing/${a.listing_id}`} className="hover:text-[#F5551E]">{a.label}</Link></td>
                  <td className="py-2.5 pr-3 text-slate-500">{a.where}</td>
                  <td className="py-2.5 pr-3 text-slate-500">{a.pending}</td>
                  <td className="py-2.5 pr-3 text-slate-500">{a.sent_count || 0}</td>
                  <td className="py-2.5 pr-3 text-slate-500">{a.created_at?.slice(0, 10)}</td>
                  <td className="py-2.5 text-right"><button onClick={() => remove(a)} data-testid={`like-delete-${a.id}`} className="text-slate-400 hover:text-red-600"><Trash2 size={15} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <p className="text-sm text-slate-400 py-6 text-center" data-testid="like-alerts-empty">None yet. Turn on the Listing pages popup in Admin → Homepage → Popups.</p>}
    </div>
  );
}
